module.exports = __webpack_public_path__ + "v294910/img/close.d519780b.png";